import {
    CHANGE_STATUS_OPEN_MODAL,
    CHANGE_STATUS_CLOSE_MODAL,
    CHANGE_STATUS_UPDATE_REQUEST,
    CHANGE_STATUS_UPDATE_RESULT,
    CHANGE_STATUS_SET_DEVICES,
    CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST,
    CHANGE_STATUS_CREATE_SCHEDULED_ACTION_RESULT,
    CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_RESULT,
    CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    devices: [],
    schedule: null,
    scheduledActions: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_REQUEST:
            return { ...state, loading: true }

        case CHANGE_STATUS_SEARCH_SCHEDULED_ACTIONS_RESULT:
            return { ...state, loading: false, scheduledActions: action.payload }

        case CHANGE_STATUS_SET_DEVICES:
            return { ...state, devices: action.payload }

        case CHANGE_STATUS_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload }

        case CHANGE_STATUS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CHANGE_STATUS_UPDATE_REQUEST:
            return { ...state, loading: true }

        case CHANGE_STATUS_UPDATE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CHANGE_STATUS_CREATE_SCHEDULED_ACTION_REQUEST:
            return { ...state, loading: true }

        case CHANGE_STATUS_CREATE_SCHEDULED_ACTION_RESULT:
            return { ...state, loading: false, schedule: action.payload }

        case CLEAR_REDUX:
            return ["", "CHANGE_STATUS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};